import FormattedMessage from 'I18n/components/FormattedMessage';
import SettingsModule from 'automation-ui-canvas/containers/settings/v2/SettingsModule';
import TimingManagement from 'automation-ui-canvas/components/settings/TimingManagement';
import { useEffect, useRef, useState } from 'react';
import TimeWindowMetadata from 'automation-ui-canvas/flow/records/properties/Timing/TimeWindowMetadata';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { SupportLinkKeys } from 'automation-ui-usage-tracking/SupportLinks';
import DocButton from 'automation-ui-usage-tracking/components/DocButton';
import { jsx as _jsx } from "react/jsx-runtime";
const ExecutionTimingSetting = ({
  flow,
  readOnly,
  settings: {
    timeWindow
  },
  onChange
}) => {
  /* Loading while timeWindow is falsy */
  const isLoading = useRef(true);
  const [isSpecificTimesToggled, setIsSpecificTimesToggled] = useState(false);
  useEffect(() => {
    if (timeWindow && isLoading.current === true) {
      isLoading.current = false;
      setIsSpecificTimesToggled(!timeWindow.hasEmptyTimeRanges());
    }
  }, [timeWindow]);
  return /*#__PURE__*/_jsx(SettingsModule, {
    header: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "settingsV2.executionTimingSetting.title"
    }),
    description: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "settingsV2.executionTimingSetting.description_jsx",
      elements: {
        Link: () => /*#__PURE__*/_jsx("div", {
          children: /*#__PURE__*/_jsx(DocButton, {
            supportKey: SupportLinkKeys.LEARN_MORE_ABOUT_EXECUTION_TIMING
          })
        })
      }
    }),
    body: /*#__PURE__*/_jsx(TimingManagement, {
      specificTimesToggled: isSpecificTimesToggled,
      handleAnytimeRadioToggled: () => {
        if (timeWindow) {
          setIsSpecificTimesToggled(false);
          onChange({
            timeWindow: timeWindow.clearTimeRanges()
          });
        }
      },
      handleSpecificTimesRadioToggled: () => {
        if (timeWindow) {
          setIsSpecificTimesToggled(true);
          onChange({
            timeWindow: timeWindow.hasEmptyTimeRanges() ? timeWindow.addTimeRange() : timeWindow
          });
        }
      },
      flow: flow,
      readOnly: readOnly,
      stagedTimeWindowMetadata: timeWindow || new TimeWindowMetadata(),
      onUpdateStagedTimeWindowMetadata: newTimeWindowMetadata => {
        onChange({
          timeWindow: newTimeWindowMetadata
        });
      },
      use: "compact"
    })
  });
};
export default ExecutionTimingSetting;